(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gth-gift-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function initGiftFinder(root) {
  if (!root || root.dataset.gthgfReady === '1') return;
  root.dataset.gthgfReady = '1';
  var raw;
  try { raw = JSON.parse(root.querySelector('[data-gthgf-data]').textContent); }
  catch (error) { console.error('GTH Gift Finder: product data could not be read', error); return; }
  var byHandle = {};
  raw.products.filter(Boolean).forEach(function (p) { byHandle[p.handle] = p; });
  var overrides = {};
  raw.overrides.filter(Boolean).forEach(function (r) { overrides[r.key] = r; });
  var result = root.querySelector('[data-gthgf-result]');
  var bank = root.querySelector('[data-gthgf-bank]');
  var hint = root.querySelector('[data-gthgf-hint]');
  var recipient = '', budget = '';
  var nativeForms = Array.from(root.querySelectorAll('[data-gthgf-native]'));
  // Do not allow native product forms to bypass HTML required fields.
  nativeForms.forEach(function(el){
    var form=el.querySelector('form');
    if(form)form.removeAttribute('novalidate');
  });
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:raw.currency || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  var prefs = {
    parents: { small:['prayer-mats','meals','chair'], medium:['wheelchairs','quran','water'], large:['wheelchairs','qurbani','quran'], flex:[['wheelchairs','quran','water'],['chair','prayer-mats','meals']] },
    passed: { small:['prayer-mats','meals','chair'], medium:['quran','wheelchairs','water'], large:['wheelchairs','qurbani','quran'], flex:[['wheelchairs','quran','water'],['quran','prayer-mats','meals']] },
    travel: { small:['meals','prayer-mats','chair'], medium:['chair','wheelchairs','quran'], large:['wheelchairs','qurbani','quran'], flex:[['wheelchairs','prayer-mats','water'],['chair','quran','water']] },
    family: { small:['meals','prayer-mats','chair'], medium:['quran','water','chair'], large:['wheelchairs','qurbani','quran'], flex:[['quran','water','meals'],['wheelchairs','prayer-mats','water']] },
    loved: { small:['prayer-mats','chair','meals'], medium:['chair','wheelchairs','quran'], large:['wheelchairs','qurbani','quran'], flex:[['chair','quran','water'],['wheelchairs','prayer-mats','quran']] },
    friend: { small:['meals','prayer-mats','chair'], medium:['quran','water','chair'], large:['wheelchairs','qurbani','quran'], flex:[['quran','water','meals'],['chair','prayer-mats','water']] },
    myself: { small:['prayer-mats','meals','chair'], medium:['quran','wheelchairs','water'], large:['wheelchairs','qurbani','quran'], flex:[['wheelchairs','quran','water'],['quran','prayer-mats','meals']] }
  };
  var intention = {
    parents:'You are honouring your parents with something that benefits pilgrims in Makkah or Madinah.',
    passed:'Remembering someone who has passed through an act of khair can be a meaningful way to give in their memory.',
    travel:'Even when someone cannot make the journey, you can dedicate a practical gift to pilgrims in their honour.',
    family:'A gift chosen together can turn your family’s shared intention into practical help for pilgrims.',
    loved:'This is a thoughtful way to turn your appreciation for someone close to your heart into an act of giving.',
    friend:'Instead of an ordinary present, you can celebrate your friendship by sharing goodness with another person.',
    myself:'A meaningful intention deserves action. This gift lets you contribute to the needs of pilgrims in the Haramain.'
  };
  var benefit = {
    'wheelchairs':'A wheelchair may assist pilgrims with mobility difficulties through repeated use, offering an opportunity to seek sadaqah jariyah, in shaa Allah.',
    'chair':'A prayer chair can make salah more comfortable for someone who has difficulty standing.',
    'prayer-mats':'A prayer mat offers a clean, useful space for a pilgrim to pray.',
    'quran':'Giving Qurans helps make copies available to pilgrims for reading and reflection.',
    'water':'Water provides refreshment to pilgrims during their visit.',
    'meals':'A meal can provide welcome nourishment to a pilgrim away from home.',
    'umbrella':'An umbrella can help offer shade to someone walking in the heat.',
    'qurbani':'Qurbani allows you to arrange a specific act of worship on an eligible basis.',
    'umrah-badal':'Umrah Badal may be meaningful where the intended beneficiary meets the religious eligibility conditions.'
  };
  // Shopify's existing line-item property names are kept verbatim for Sheets.
  function productKind(product) {
    var h = String(product && product.handle || '').toLowerCase();
    if (h.indexOf('umrah') !== -1) return 'umrah';
    if (h.indexOf('wheelchair') !== -1) return 'wheelchair';
    if (h.indexOf('qurbani') !== -1) return 'qurbani';
    if (h.indexOf('chair') !== -1) return 'chair';
    return '';
  }
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function markGiftFinderCart(selection) {
    return fetch(cartRoot + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({attributes:{'Gift Finder Source':'Gift Finder','Gift Finder Selection':selection}})
    }).then(function(r) { if(!r.ok) throw new Error('Cannot record source'); return r; });
  }
  function trackProductLink(a, variantId, isAlt) {
    a.addEventListener('click', function(e) {
      if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var target = a.href;
      a.setAttribute('aria-busy','true');
      // Track the checkout journey without renaming existing product form fields.
      markGiftFinderCart(recipient + ' / ' + budget + ' / ' + (isAlt?'Alternative':'Main') + ' / ' + variantId)
        .catch(function(){})
        .then(function(){window.location.assign(target);});
    });
  }
  function labelInput(text, required) {
    var label = node('label','gthgf__field',text + (required ? ' *' : ''));
    var field = node('input'); field.type='text';field.maxLength=120;field.required=!!required;field.autocomplete='off';
    label.append(field);return {element:label,input:field};
  }
  function radioGroup(label, values) {
    var fs=node('fieldset','gthgf__choice-field');fs.append(node('legend','',label+' *'));
    var radios=[];
    values.forEach(function(value) {
      var l=node('label'); var r=node('input');r.type='radio';r.name='gthgf-pending';
      // Single group name shared by all controls.
      radios.push(r); l.append(r);l.append(document.createTextNode(' '+value));fs.append(l);
    });
    var group='gthgf-'+(++radioGroup.seq); radios.forEach(function(r){r.name=group;r.required=true;});
    return {element:fs,values:values,radios:radios};
  }
  radioGroup.seq=0;
  function extraFieldsFor(product) {
    var kind=productKind(product), elements=[], controls=[];
    var obj={kind:kind,elements:elements,valid:function(){
      for(var i=0;i<controls.length;i++){
        var c=controls[i];
        if(c.kind==='text' && !c.field.value.trim()){c.field.focus();c.field.reportValidity();return false;}
        if(c.kind==='radio' && !c.group.radios.some(function(r){return r.checked;})){
          c.group.radios[0].focus();c.group.radios[0].reportValidity();return false;
        }
      }
      return true;
    },properties:function(){
      var props={};controls.forEach(function(c){
        if(c.kind==='text') props[c.key]=c.field.value.trim();
        else {var n=c.group.radios.findIndex(function(r){return r.checked;});if(n!==-1)props[c.key]=c.group.values[n];}
      });return props;
    }};
    if(!kind)return obj;
    var fieldLabel=kind==='chair'?'Name to Be Written on the Chair':kind==='qurbani'?'Beneficiary’s Full Name':'Full Name(s) of Beneficiary';
    var bn=labelInput(fieldLabel,true);
    elements.push(bn.element);controls.push({kind:'text',key:'Full Name of Beneficiary',field:bn.input});
    if(kind==='umrah'){
      elements.unshift(node('p','gthgf__note','Umrah Badal is for eligible beneficiaries such as the deceased, chronically ill or physically unable.'));
      var rl=labelInput('Relationship to Requestor',true);
      elements.push(rl.element);controls.push({kind:'text',key:'Relationship to Requestor',field:rl.input});
      var gender=radioGroup('Gender',['Male','Female']);elements.push(gender.element);controls.push({kind:'radio',key:'Gender',group:gender});
      var reason=radioGroup('Reason for Umrah Badal',['Deceased','Chronically ill','Physically Unable']);elements.push(reason.element);controls.push({kind:'radio',key:'Reason for Umrah Badal',group:reason});
    }
    return obj;
  }
  function node(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }
  function imageFor(p) {
    if (p.image) {
      var img = node('img');
      img.src = p.image;
      img.alt = p.title;
      img.loading = 'lazy';
      img.width = 110;
      img.height = 110;
      return img;
    }
    return node('div', 'gthgf__img-empty', 'Image not uploaded');
  }
  function availableVariants(p, name) {
    return (p && p.variants || []).filter(function (v) { return v.available && (name === 'flex' ||
      (name === 'small' && v.price < 5000) ||
      (name === 'medium' && v.price >= 5000 && v.price <= 20000) ||
      (name === 'large' && v.price > 20000)); });
  }
  function findProduct(preferred, name, exclude) {
    var seen = {};
    var handles = (preferred || []).concat(Object.keys(byHandle));
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i], p = byHandle[h];
      if (!p || seen[h] || h === exclude) continue;
      seen[h] = true;
      var v = availableVariants(p, name)[0];
      if (v) return {product:p, variant:v};
    }
    return null;
  }
  function productView(match, compact) {
    var p = match.product, v = match.variant;
    var wrap = node('div', 'gthgf__product');
    var a = node('a');
    a.href = p.url + '?variant=' + encodeURIComponent(v.id);
    trackProductLink(a, v.id, !!compact);
    a.append(imageFor(p));
    wrap.append(a);
    var right = node('div');
    right.append(node('strong', '', p.title));
    right.append(node('p', '', money(v.price)));
    if (!compact && v.title !== 'Default Title') right.append(node('small', '', v.title));
    wrap.append(right);
    return wrap;
  }
  function whyCopy(rec, p, override) {
    if (override && override.trim()) return override.trim();
    return (intention[rec] || intention.myself) + ' ' + (benefit[p.handle] || 'It is a practical way to share goodness with pilgrims.');
  }
  function title(text) { return node('p', 'gthgf__eyebrow-result', text); }
  function why(text) {
    var box = node('div','gthgf__why');
    box.append(node('strong','', 'Why we recommend this'));
    box.append(node('p','', text));
    return box;
  }
  function link(label, href, cls) {
    var a = node('a',cls,label);
    a.href = href;
    return a;
  }
  function restoreForms() {
    nativeForms.forEach(function (el) { el.hidden = true; bank.append(el); });
  }
  function renderStandard(config) {
    var pref = (prefs[recipient] || prefs.myself)[budget];
    var chosen = findProduct([config.product].concat(pref).filter(Boolean), budget);
    var second = findProduct([config.alternative].concat(pref).filter(Boolean), budget, chosen && chosen.product.handle);
    // The merchant's selected product is preferred, but never shown outside a fixed budget.
    if (!chosen) {
      result.append(node('h3','', 'Explore our available gifts'));
      result.append(node('p','gthgf__note', 'There is no available product variant within this price range right now.'));
      result.append(link('Explore All Gifts →',raw.allUrl,'gthgf__primary'));
      return;
    }
    result.append(title('A GIFT CHOSEN FOR YOUR INTENTION'));
    result.append(node('h3','', 'A Meaningful Gift for You'));
    result.append(productView(chosen,false));
    result.append(why(whyCopy(recipient,chosen.product,config.reason)));
    var mainLink=link(raw.cta || "Alhumdulillah, I'm Ready to Give",chosen.product.url+'?variant='+encodeURIComponent(chosen.variant.id),'gthgf__primary');
    trackProductLink(mainLink,chosen.variant.id,false);result.append(mainLink);
    if (second) {
      var alt = node('div','gthgf__alternative');
      alt.append(node('span','gthgf__mini-title','ANOTHER GIFT TO CONSIDER'));
      alt.append(productView(second,true));
      var altLink=link('View This Gift →',second.product.url+'?variant='+encodeURIComponent(second.variant.id),'gthgf__small-link');
      trackProductLink(altLink,second.variant.id,true);alt.append(altLink);
      result.append(alt);
    }
  }
  function buildBundleSlot(slot, handles, label, config) {
    var box = node('div','gthgf__package'+(slot === 2?' gthgf__package--alt':''));
    box.append(node('span','gthgf__mini-title',slot === 1?'OUR RECOMMENDED PACKAGE':'ALTERNATIVE GIFT PACKAGE'));
    box.append(node('h4','',label));
    var native = nativeForms.find(function (el) { return el.dataset.gthgfNative === recipient+'-flex-'+slot; });
    if (native) { native.hidden = false; box.append(native); result.append(box); return; }
    var chosen = handles.map(function (handle) { return byHandle[handle]; });
    var unavailable = chosen.some(function (p) { return !p || !availableVariants(p,'flex').length; });
    if (unavailable) {
      box.append(node('p','gthgf__note','This combination is temporarily unavailable. Choose other bundle products in the Shopify theme editor.'));
      result.append(box); return;
    }
    var selectors = [];
    var customization = [];
    chosen.forEach(function (p) {
      var item = node('div','gthgf__package-item');
      item.append(imageFor(p));
      var detail = node('div');detail.append(node('strong','',p.title));
      var variants=availableVariants(p,'flex');
      var selected=variants[0];
      var variantSelector = null;
      // Products can have up to three real Shopify option dimensions.
      // Render all dimensions for Umrah Badal when its product defines them.
      if(productKind(p)==='umrah' && Array.isArray(p.options) && p.options.length > 1){
        var optionSelects=[];
        p.options.forEach(function(optionName,idx){
          var field=node('label','gthgf__field',optionName);
          var sel=node('select');sel.required=true;
          var values=[];
          variants.forEach(function(v){var value=v.options && v.options[idx];if(value && values.indexOf(value)<0)values.push(value);});
          values.forEach(function(value){var opt=node('option','',value);opt.value=value;sel.append(opt);});
          if(selected.options && selected.options[idx])sel.value=selected.options[idx];
          field.append(sel);detail.append(field);optionSelects.push(sel);
        });
        variantSelector={value:function(){
          return variants.find(function(v){return optionSelects.every(function(s,i){return v.options[i]===s.value;});})||null;
        },onChange:function(fn){optionSelects.forEach(function(s){s.addEventListener('change',fn);});}};
      }else{
        var field=node('label','gthgf__field','Quantity & location');
        var sel=node('select');sel.setAttribute('aria-label','Choose an option for '+p.title);sel.required=true;
        variants.forEach(function(v){
          var opt=node('option','',v.title+' — '+money(v.price));opt.value=String(v.id);sel.append(opt);
        });
        field.append(sel);detail.append(field);
        variantSelector={value:function(){return variants.find(function(v){return String(v.id)===sel.value;})||null;},onChange:function(fn){sel.addEventListener('change',fn);}};
      }
      item.append(detail);box.append(item);
      selectors.push(variantSelector);
      var extra=extraFieldsFor(p);
      extra.elements.forEach(function(el){detail.append(el);});
      customization.push(extra);
    });
    var total = node('div','gthgf__total');
    total.append(node('span','','Package total'));
    var amount = node('strong'); total.append(amount); box.append(total);
    function updateTotal(){
      var cents=0,allValid=true;
      selectors.forEach(function(s){var v=s.value();if(v)cents+=Number(v.price);else allValid=false;});
      amount.textContent=allValid?money(cents):'Select available options';
    }
    selectors.forEach(function(s){s.onChange(updateTotal);});
    updateTotal();
    var btn=node('button','gthgf__primary',raw.bundleCta || 'Add These Gifts to Cart');
    btn.type='button';box.append(btn);
    var error=node('p','gthgf__error');error.hidden=true;error.setAttribute('role','alert');box.append(error);
    box.append(node('p','gthgf__note','These are separate Shopify products added together at their current prices. Payment continues securely from your cart.'));
    btn.addEventListener('click', function () {
      error.hidden=true;error.textContent='';
      var variants=selectors.map(function(s){return s.value();});
      if(variants.some(function(v){return !v;})){
        error.hidden=false;error.textContent='Choose a valid, available variant for every gift.';return;
      }
      for(var n=0;n<customization.length;n++){
        if(!customization[n].valid()){
          error.hidden=false;error.textContent='Please complete the required beneficiary information for '+chosen[n].title+'.';return;
        }
      }
      var items=variants.map(function(v,i){
        var props={'_Gift Finder Source':'Gift Finder','_Gift Finder Selection':recipient+' / Flexible / '+(slot===1?'Main':'Alternative')};
        Object.assign(props,customization[i].properties());
        return {id:Number(v.id),quantity:1,properties:props};
      });
      var old=btn.textContent;btn.disabled=true;btn.textContent='Adding your gifts…';
      var shopRoot=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Unable to add gifts.');return j;});})
        .then(function(){window.location.assign(raw.checkoutUrl || '/cart');})
        .catch(function(err){btn.disabled=false;btn.textContent=old;error.hidden=false;error.textContent=err.message||'Please try again.';});
    });
    result.append(box);
  }
  function renderFlexible(config) {
    var pair=(prefs[recipient] || prefs.myself).flex;
    var main=pair[0].map(function(h,i){return config.bundle && config.bundle[i] || h;});
    var alt=pair[1].map(function(h,i){return config.otherBundle && config.otherBundle[i] || h;});
    result.append(title('TWO PACKAGES CHOSEN FOR YOUR INTENTION'));
    result.append(node('h3','', 'More Ways to Share Khair'));
    var names=main.map(function(h){return byHandle[h]&&byHandle[h].title;}).filter(Boolean).join(', ');
    var reason=config.reason && config.reason.trim() ||
      ((intention[recipient]||intention.myself)+' Combining complementary gifts such as '+names+' lets your khair serve different needs. A wheelchair or prayer chair may also provide benefit through repeated use, in shaa Allah.');
    result.append(why(reason));
    buildBundleSlot(1,main,'A Meaningful Gift Package',config);
    buildBundleSlot(2,alt,'Another Way to Give',config);
  }
  function update() {
    restoreForms(); result.replaceChildren();
    if (!recipient || !budget) {result.hidden=true;hint.hidden=false;return;}
    var key=recipient+'-'+budget;
    var config=overrides[key]||{};
    if (budget==='flex') renderFlexible(config); else renderStandard(config);
    var reset=node('button','gthgf__reset','Choose Again ↺');reset.type='button';
    reset.addEventListener('click',function(){recipient='';budget='';root.querySelectorAll('[data-recipient],[data-budget]').forEach(function(b){b.setAttribute('aria-pressed','false');});update();root.querySelector('.gthgf__panel').scrollIntoView({behavior:'smooth',block:'nearest'});});
    result.append(reset);
    result.hidden=false;hint.hidden=true;
    result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
  }
  root.querySelectorAll('[data-recipient],[data-budget]').forEach(function(btn) {
    btn.addEventListener('click', function(){
      var group=btn.hasAttribute('data-recipient')?'recipient':'budget';
      if(group==='recipient')recipient=btn.dataset.recipient;else budget=btn.dataset.budget;
      root.querySelectorAll('[data-'+group+']').forEach(function(b){b.setAttribute('aria-pressed',String(btn===b));});
      update();
    });
  });
  } // End per-section initializer
  function initAllGiftFinders() {
    document.querySelectorAll('[data-gthgf]').forEach(initGiftFinder);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGiftFinders);
  } else {
    initAllGiftFinders();
  }
  document.addEventListener('shopify:section:load', initAllGiftFinders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
